export const getCurrentTimeStamp = () => {
    return Math.floor(Date.now() / 1000);
}

export const getLastSevenDayTimeStamp = () => {
    return Math.floor(Date.now() / 1000) - 604800;
}